module.exports = __webpack_public_path__ + "img/auth-background.6c708e90.png";